import Vue from 'vue'
import axios from './axios'
import store from '@/store'

const { transformResponse } = axios.defaults

axios.defaults.transformResponse = [(data) => {
  try {
    const result = JSON.parse(data)

    if (result.code === 'user-not-login' && result.data) {

      // 接入微前端时
      if (window.__POWERED_BY_QIANKUN__) {
        // if(process.env) {
        //   for(let i in process.env) {
        //     Vue.prototype.$message.info(process.env[i])
        //   }
        // }
        // Vue.prototype.$message.info('process.env.VUE_APP_DOMIAN_SSO_URL：'+process.env.VUE_APP_DOMIAN_SSO_URL)
        let url = `${process.env.VUE_APP_DOMIAN_SSO_URL}/login/success?ticket=${Vue.prototype.$ssoAccessToken}&redirectUrl=${encodeURIComponent(window.location.href)}`
        window.location.replace(url)
      } else { // 独立运行时，按照原逻辑
        let url = result.data.replace(
          /(redirectUrl)=?[^&]*/i,
          `$1=${encodeURIComponent(window.location.href)}`
        )
        if (process.env.VUE_APP_LOGIN_WAY === '1') {
          // 内网域登录方式
          if (window.top === window.self) {
            // cancelUrl 用户点击登录框取消操作时后台回调作用(具体详情查看redirect组件)
            let cancelUrl = window.location.href.replace(
              /(\/#\/)(\s*)[^?]*/,
              `$1redirect`
            )
            url = url.replace(
              /(http|https):\/\/[^?]*/i,
              `${process.env.VUE_APP_DOMAIN_LOGIN_URL}`
            )
            url = `${url}&cancelUrl=${encodeURIComponent(cancelUrl)}/#/login`
            store.commit('global/SET_LOGIN_URL', url)
            // 内网域登录
            store.dispatch('global/domainLogin')
          }
        } else {
          // 外网sso登录方式
          window.location.replace(url)
        }
      }
    }
  } catch (error) {
    /* eslint-disable-line */
  }

  return data
}].concat(transformResponse)

const sso = {
  signIn() {
  // console.log(window.__POWERED_BY_QIANKUN__, 'window.__POWERED_BY_QIANKUN__')
  // console.log(Vue.prototype.$ssoAccessToken, '$ssoAccessToken')
  // console.log(window.location.href, 'window.location.href')
  // console.log(process.env.VUE_APP_DOMIAN_SSO_URL, 'process.env.VUE_APP_DOMIAN_SSO_URL')
  // let url = `https://i-test.test.geely.com/login/success?ticket=${Vue.prototype.$ssoAccessToken}&redirectUrl=${encodeURIComponent('https://gis.test.geely.com/i_geely')}`
  // console.log(url, 'url-lre')
  // window.location.replace(url)
  // Vue.prototype.$setGlobalState({loginSuccess: true})
    
    return axios.get('/api/session/session-info').then((res) => {
      if (window.top === window.self) { // 为true表示当前窗口就是顶层窗口,没有iframe应用;
        // localStorage.setItem('geely-sso-userId', res.data.userId)
        store.commit('global/SET_LOGIN_INFO', res.data)
        // 域登录时修改登录状态
        if (process.env.VUE_APP_LOGIN_WAY === '1') {
          store.commit('global/CHANGE_LOADING', false)
          if (document.getElementById('AD-LOGIN')) {
            document.body.removeChild(document.getElementById('AD-LOGIN'))
          }
        }
        // // 接入微前端的情况下，登录后向主应用发送登录成功通知
        // if(window.__POWERED_BY_QIANKUN__) {
        //   Vue.prototype.$setGlobalState({loginSuccess: true})
        // }
      } else {
        // 内网域登录时 在子Iframe中通知父窗口登录成功
        window.parent.LOGIN.loginSuccess()
      }
    })
  },
  signOut() {
    return axios.delete('/api/session/logout').then(() => {
      // Navigate to SSO home page by signing in again.
      sso.signIn()
    })
  }
}

Vue.sso = sso
Vue.prototype.$sso = sso

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  sso.signIn()
}

export default sso
